import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetPermitsAssociation } from "../../../apis/actions/photoVideos.actions";
import Loader from "../../../biblio/Loader/Loader";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import PreviewMedia from "../../../biblio/PreviewMedia/PreviewMedia";

const PermitsAssociation = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { permits, loading } = useSelector(
    (state: RootState) => state.photoVideo
  );

  useEffect(() => {
    dispatch(toGetPermitsAssociation());
  }, [dispatch]);

  if (loading) return <Loader />;
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="من نحن"
      subTitle={"تصاريح الجمعية"}
      urlImage={banner}
      className="takaful--our-story"
    >
      <PreviewMedia
        mediaItems={permits}
        loading={loading}
        itemPerPage={6}
        isVideo={false}
      />
    </MenuItemLayout>
  );
};

export default PermitsAssociation;
